import { render, staticRenderFns } from "./ShuttleFilter.vue?vue&type=template&id=5d5d6c2c&scoped=true&"
import script from "./ShuttleFilter.vue?vue&type=script&lang=js&"
export * from "./ShuttleFilter.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleFilter.vue?vue&type=style&index=0&id=5d5d6c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d6c2c",
  null
  
)

export default component.exports